import { createSlice } from '@reduxjs/toolkit'
import { PURGE } from "redux-persist";

const initialState = {
    role:0,
    name:"",
}

export const userRoleSlice = createSlice({
    name: 'userRoleSlice',
    initialState,
    reducers: {
        setUserRole:(state,action)=>{
            state.role=action.payload
        },
        setUserName:(state,action)=>{
            state.name=action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(PURGE, () => initialState); // THIS LINE
    }
})

export const { setUserRole,resetRole,setUserName} = userRoleSlice.actions
export default userRoleSlice.reducer